import { computed, onMounted, onUnmounted, ref } from 'vue'

import { ScreenBreakpoint, screenSize } from '@shared/models/enums/screen-sizes'

export function useWindowSize() {
  const windowWidth = ref(window.innerWidth)
  const windowHeight = ref(window.innerHeight)

  const getWindowSize = (breakpoint: ScreenBreakpoint) => {
    return windowWidth.value >= breakpoint
  }

  const currentScreenSize = computed(() => {
    for (const size in ScreenBreakpoint) {
      if (
        getWindowSize(ScreenBreakpoint[size as keyof typeof ScreenBreakpoint])
      ) {
        return screenSize[
          ScreenBreakpoint[size as keyof typeof ScreenBreakpoint]
        ]
      }
    }
    return screenSize[ScreenBreakpoint.XS]
  })

  const isSmallScreen = computed(() => {
    const smallScreensBreakpoints = [
      screenSize[ScreenBreakpoint.XS],
      screenSize[ScreenBreakpoint.SM],
      screenSize[ScreenBreakpoint.SMALL_TABLET],
    ]

    return smallScreensBreakpoints.includes(currentScreenSize.value) // max width: 768
  })

  const isMediumScreen = computed(() => {
    const mediumScreensBreakpoints = [
      screenSize[ScreenBreakpoint.MD],
      screenSize[ScreenBreakpoint.SMALL_TABLET],
      screenSize[ScreenBreakpoint.XS],
      screenSize[ScreenBreakpoint.SM],
    ]

    return mediumScreensBreakpoints.includes(currentScreenSize.value) // max width: 1024
  })

  const isMobileScreen = computed(() => {
    return currentScreenSize.value === screenSize[ScreenBreakpoint.XS]
  })

  const isMobileVersionScreen = computed(() => {
    const smallTabletBreakpoints = [
      screenSize[ScreenBreakpoint.XS],
      screenSize[ScreenBreakpoint.SM],
    ]

    return smallTabletBreakpoints.includes(currentScreenSize.value)
  })

  const onWidthChange = () => {
    windowWidth.value = window.innerWidth
    windowHeight.value = window.innerHeight
  }

  const screenHeight = computed(() => windowHeight.value)

  onMounted(() => window.addEventListener('resize', onWidthChange))
  onUnmounted(() => window.removeEventListener('resize', onWidthChange))

  return {
    currentScreenSize,
    isSmallScreen,
    isMediumScreen,
    isMobileScreen,
    isMobileVersionScreen,
    screenHeight,
  }
}
